import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import * as _ from "lodash";
import * as Moment from "moment";
import Linkify from "linkify-react";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "../../../utils/image";
import { useDispatch, useSelector } from "react-redux";
import { listAttachmentByMessageId } from "../../../store/attachment/thunkAction";
import {
  addNote,
  editNote,
  listNoteByMessageId,
  removeNote,
} from "../../../store/note/thunkAction";
import { editMessage, readMessage } from "../../../store/message/thunkAction";
import { noteAction } from "../../../store/note/slice";
import Popup from "../../core/popup";
import {
  DateFormat,
  MessageStyle,
  MessageType,
  TimeFormat,
} from "../../../constant/enums";
const EMPTY_IMAGE = "/img/chat/empty.jpg";

const ChatContent = ({ message, config }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isWidget = _.get(config, "isWidget", false);
  const timeZone = _.get(config, "timeZone", null);
  const timeFormat = _.get(config, "timeFormat", TimeFormat.FORMAT_12H);
  const dateFormat = _.get(config, "dateFormat", DateFormat.DD_MM_YYYY);
  const staffNameDefault = _.get(config, "staffNameDefault", "");
  const messageStyle = _.get(config, "messageStyle", MessageStyle.SIMPLE_LINES);
  const onReplyMessage = _.get(config, "onReplyMessage", () => {});
  const isLastMessage = _.get(config, "isLastMessage", false);
  const isShowTime = _.get(config, "isShowTime", false);
  const isSeen = _.get(config, "isSeen", false);
  const [isAddNote, setIsAddNode] = useState(false);
  const [contentNote, setContentNote] = useState("");
  const [note, setNote] = useState({});
  const requesterId = _.get(message, "requesterId", null);
  const messageId = _.get(message, "_id");
  const accountId = _.get(message, "accountId");
  const messageSessionId = _.get(message, "sessionId");
  const noteIds = _.get(message, "noteIds", []);
  const type = _.get(message, "type", MessageType.TEXT);
  const content = _.get(message, "content", "");
  const name = _.get(message, "name", "");
  const replyMessageId = _.get(message, "replyMessageId", null);
  const [showButton, setShowButton] = useState(false);
  const divRef = useRef(null);
  const setReplyMessageId = _.get(config, "setReplyMessageId", () => {});

  const addTime = _.get(message, "addTime");
  const messageStaffId = _.get(message, "staffId");
  const isRequester = !!requesterId;

  const [isImageOpen, setIsImageOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  const focusDiv = () => {
    if (divRef.current) {
      divRef.current.focus({ preventScroll: true });
    }
  };

  const optionContentNotWidget = {
    target: "_blank",
    rel: "noopener noreferrer",
  };

  const optionContentWidget = {
    target: "_blank",
    rel: "noopener noreferrer",
    className: "custom-link",
  };

  const handleImageClick = (src) => {
    setImageSrc(src);
    setIsImageOpen(true);
  };

  const handleCloseImage = () => {
    setIsImageOpen(false);
    setImageSrc(null);
  };

  const getFormattedTime = (time) => {
    const format = timeFormat === "12H" ? "hh:mm A" : "HH:mm";

    if (_.isNumber(timeZone)) {
      const offsetInMinutes = timeZone * 60;
      return Moment(time).utcOffset(offsetInMinutes).format(format);
    }

    return Moment(time).format(format);
  };

  const getMessageBodyClass = () => {
    // if (messageStyle === MessageStyle.SPEECH_BUBBLES) {
    //   if (isRequester) {
    //     return "chat-mess-body speech-bubbles-right";
    //   }
    //   return "chat-mess-body speech-bubbles-left";
    // }
    return "chat-mess-body simple-lines";
  };

  const requesterManage = useSelector((state) => state.requesterManage);
  const requester = _.get(requesterManage, "requester");
  const attachmentManage = useSelector((state) => state.attachmentManage);
  const attachments = _.get(attachmentManage, "attachments", {});
  const noteManage = useSelector((state) => state.noteManage);
  const messageManage = useSelector((state) => state.messageManage);
  const replyMessages = _.get(messageManage, "message", {});
  const notes = _.get(noteManage, "notes", {});
  const isLoadingAddNote = _.get(noteManage, "isLoadingAddNote", false);
  const staffManage = useSelector((state) => state.staffManage);
  const staff = _.get(staffManage, "staff", {});
  const staffs = _.get(staffManage, "staffs", {});
  const staffId = _.get(staff, "_id");
  const isMe = messageStaffId === staffId;
  const sessionManage = useSelector((state) => state.sessionManage);
  const session = _.get(sessionManage, "session");
  const sessionId = _.get(session, "_id");

  const isWidgetRequester = isWidget && isRequester;
  const isWidgetStaff = isWidget && !isRequester;
  const isMeNotWidget = !isWidget && isMe;
  const isOtherNotWidget = !isWidget && !isMe;

  useEffect(() => {
    if (type === MessageType.FILE) {
      dispatch(listAttachmentByMessageId(messageId));
    }
  }, [dispatch, messageId, type]);

  useEffect(() => {
    if (replyMessageId) {
      dispatch(readMessage(replyMessageId));
      dispatch(listAttachmentByMessageId(replyMessageId));
    }
  }, [dispatch, replyMessageId]);

  useEffect(() => {
    if (messageId && noteIds.length) {
      dispatch(listNoteByMessageId(messageId));
    }
  }, [dispatch, messageId, noteIds]);

  useEffect(() => {
    const noteId = _.get(note, "_id");
    const content = _.get(note, "content", "");
    if (noteId) {
      setContentNote(content);
    }
  }, [note]);

  const saveNote = async () => {
    const noteId = _.get(note, "_id");
    const name = _.get(staff, "name");
    const now = +Moment.utc();

    const data = {
      accountId,
      sessionId: messageSessionId,
      messageId,
      staffId,
      name,
      content: contentNote,
      addTime: now,
      updateTime: now,
    };

    try {
      let result = null;

      if (!noteId) {
        if (isLoadingAddNote) {
          return;
        }
        result = await dispatch(addNote(data)).unwrap();
      }

      if (noteId) {
        result = await dispatch(
          editNote({
            id: noteId,
            data: {
              content: contentNote,
            },
            updateTime: now,
          })
        ).unwrap();
      }

      const newNoteId = _.get(result, "_id");

      if (newNoteId) {
        if (!noteId) {
          await dispatch(
            editMessage({
              id: messageId,
              data: {
                noteIds: _.uniq([...noteIds, newNoteId]),
                updateTime: now,
              },
            })
          ).unwrap();
        }

        dispatch(listNoteByMessageId(messageId));
        setContentNote("");
        setIsAddNode(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const removeNoteMessage = async (note) => {
    const noteId = _.get(note, "_id");
    const newNoteIds = _.filter(noteIds, (id) => id !== noteId);
    if (noteId) {
      await dispatch(removeNote(noteId)).unwrap();
      await dispatch(
        editMessage({
          id: messageId,
          data: {
            noteIds: newNoteIds,
            updateTime: +Moment.utc(),
          },
        })
      ).unwrap();

      if (newNoteIds.length) {
        dispatch(listNoteByMessageId(messageId));
        return;
      }

      dispatch(noteAction.clearNoteByMessageId(messageId));
    }
  };

  const fileTypeIcon = (name, type) => {
    const ext = name.split(".").pop()?.toLowerCase() || "";

    if (type.includes("pdf") || ext === "pdf") return "pdf";
    if (type.includes("word") || ["doc", "docx"].includes(ext)) return "word";
    if (type.includes("excel") || ["xls", "xlsx"].includes(ext)) return "excel";

    return "default";
  };

  const attachmentFile = (attachments) => {
    return _.filter(
      attachments,
      (attachment) => !_.startsWith(_.get(attachment, "type", ""), "image")
    );
  };

  const attachmentImage = (attachments) => {
    return _.filter(attachments, (attachment) =>
      _.startsWith(_.get(attachment, "type", ""), "image")
    );
  };

  return (
    <div
      id={messageId}
      tabIndex={0}
      style={{
        outline: "none",
      }}
      onFocus={() => setShowButton(true)}
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
          setShowButton(false);
        }
      }}
      ref={divRef}
      onMouseEnter={focusDiv}
    >
      {isAddNote && !isWidget && (
        <div className="chat-note-box d-flex position-relative">
          {" "}
          <input
            className="form-control bg-warning-light rounded-5 border-0"
            placeholder={t("agent.chat.write_note")}
            value={contentNote}
            onChange={(e) => setContentNote(e.target.value)}
          />{" "}
          <div className="chat-note-action">
            {" "}
            <button
              className="btn-note-save color-info button-note"
              onClick={() => saveNote()}
            >
              {t("common.save")}
            </button>{" "}
            <button
              className="btn-note-cancel button-note"
              onClick={() => {
                setContentNote("");
                setIsAddNode(false);
              }}
            >
              {t("common.cancel")}
            </button>{" "}
          </div>
        </div>
      )}
      {!isWidget &&
        (notes[messageId] || []).map((note, index) => (
          <div
            id={note._id}
            key={index}
            className="chat-note-box d-flex position-relative"
          >
            <div className="form-control align-items-center bg-warning-light rounded-5 d-flex gap-2">
              <img
                width="11px"
                height="15px"
                className="mt-1"
                src="/img/chat/icon/note.svg"
                alt=""
              />
              <div>
                <span className="fw-semibold">
                  {staffs[note.staffId]?.name || ""} {t("agent.chat.noted")}:
                </span>{" "}
                {note.content}.
              </div>
            </div>
            <div className="chat-note-action dropdown">
              <button
                className="w-100 btn bg-transparent p-0 border-0 dropdown-toggle dropdown-toggle-tips"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-ellipsis-v"></i>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setNote(note);
                      setIsAddNode(true);
                    }}
                  >
                    Edit
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => removeNoteMessage(note)}
                  >
                    Delete
                  </button>
                </li>
              </ul>
            </div>
          </div>
        ))}
      {type === MessageType.INFO && (
        <div className="text-center color-gray date">
          <strong className="color-dark">{name} </strong> {content}
          <span className="time color-gray">
            {" "}
            - {getFormattedTime(addTime)}
          </span>
        </div>
      )}
      {type === MessageType.NOTIFY && (
        <div className="text-center color-gray date">
          <span className="time color-gray">{content}</span>
          <span className="time color-gray">
            {" "}
            - {getFormattedTime(addTime)}
          </span>
        </div>
      )}
      {(type === MessageType.TEXT || type === MessageType.FILE) && (
        <div>
          {isWidgetRequester && (
            <div>
              <div
                className="chat-mess-box chat-mess-right"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="chat-mess d-flex align-items-center gap-2 justify-content-end">
                  {showButton && sessionId === messageSessionId && (
                    <button
                      className="btn btn-gray-light chat-btn-reply"
                      onClick={() => onReplyMessage(message)}
                    >
                      <img src="/img/chat/icon/reply.svg" alt="" />
                    </button>
                  )}
                  <div
                    className={`${getMessageBodyClass()} rounded-3`}
                    style={{
                      background: "none",
                    }}
                  >
                    {replyMessages[replyMessageId] && (
                      <div
                        style={{
                          backgroundColor: "#EDD6F9",
                          color: "black",
                          borderTopLeftRadius: 8,
                          borderTopRightRadius: 8,
                        }}
                        className="chat-mess-reply bg-gray-light p-2"
                        onClick={() => setReplyMessageId(replyMessageId)}
                      >
                        <div className="border-start bg-gray border-2 ps-2">
                          <div>
                            {_.get(replyMessages[replyMessageId], "name", "")}
                          </div>
                          <div className="one-line small color-gray">
                            {_.get(
                              replyMessages[replyMessageId],
                              "content",
                              ""
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              paddingTop: "2px",
                              gap: "2px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "flex-end",
                                gap: "2px",
                              }}
                            >
                              {attachmentImage(
                                attachments[replyMessageId] || []
                              ).map((attachment, index) => {
                                const url = _.get(attachment, "url")
                                  ? getImageUrl(_.get(attachment, "url", ""))
                                  : _.get(
                                      attachment,
                                      "previewUrl",
                                      EMPTY_IMAGE
                                    );
                                const name = _.get(attachment, "name", "");

                                return (
                                  <div
                                    key={index}
                                    className="img rounded-2"
                                    style={{
                                      backgroundColor: "#EBE5F6",
                                      border: "1px solid #7250C8",
                                      width: "70px",
                                      height: "70px",
                                    }}
                                  >
                                    <img
                                      src={url}
                                      alt={name}
                                      className="chat-attachment-image rounded"
                                      style={{
                                        height: "68px",
                                        width: "68px",
                                      }}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-end",
                                flexDirection: "column",
                                gap: "2px",
                              }}
                            >
                              {attachmentFile(
                                attachments[replyMessageId] || []
                              ).map((attachment, index) => {
                                const url = _.get(attachment, "url")
                                  ? getImageUrl(_.get(attachment, "url", ""))
                                  : _.get(
                                      attachment,
                                      "previewUrl",
                                      EMPTY_IMAGE
                                    );
                                const name = _.get(attachment, "name", "");
                                const type = _.get(attachment, "type", "");
                                const iconType = fileTypeIcon(name, type);

                                return (
                                  <div
                                    key={index}
                                    className="chat-mess-body rounded-4 p-2 px-3 border-pri"
                                    style={{
                                      minWidth: "150px",
                                    }}
                                  >
                                    <div className="chat-mess-text d-flex gap-2 align-items-center">
                                      {iconType === "pdf" && (
                                        <img
                                          src="/img/chat/icon/pdf.svg"
                                          alt="pdf"
                                          width={18}
                                        />
                                      )}
                                      {iconType === "word" && (
                                        <img
                                          src="/img/chat/icon/word.svg"
                                          alt="word"
                                          width={18}
                                        />
                                      )}
                                      {iconType === "excel" && (
                                        <img
                                          src="/img/chat/icon/excel.svg"
                                          alt="excel"
                                          width={18}
                                        />
                                      )}
                                      {iconType === "default" && (
                                        <svg
                                          className="icon"
                                          width="15"
                                          height="18"
                                          viewBox="0 0 15 18"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                                            fill="#211F26"
                                          />
                                        </svg>
                                      )}
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={url}
                                        style={{
                                          maxWidth: "160px",
                                          direction: "rtl",
                                          textAlign: "left",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          color: "black",
                                        }}
                                        className="ellipsis-start"
                                      >
                                        <strong>{name}</strong>
                                      </a>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {content && (
                      <div
                        className="chat-mess-text content-me-widget p-2 px-3"
                        style={{
                          whiteSpace: "pre-wrap",
                          with: "100%",
                          borderBottomLeftRadius: 8,
                          borderBottomRightRadius: 8,
                          ...(replyMessages[replyMessageId]
                            ? {}
                            : {
                                borderTopLeftRadius: 8,
                                borderTopRightRadius: 8,
                              }),
                        }}
                      >
                        <Linkify options={optionContentWidget}>
                          {content}
                        </Linkify>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "flex-end",
                        gap: "2px",
                        paddingTop: "2px",
                      }}
                    >
                      {attachmentImage(attachments[messageId] || []).map(
                        (attachment, index) => {
                          const url = _.get(attachment, "url")
                            ? getImageUrl(_.get(attachment, "url", ""))
                            : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                          const name = _.get(attachment, "name", "");

                          return (
                            <div
                              key={index}
                              className="img rounded-2"
                              style={{
                                backgroundColor: "#EBE5F6",
                                border: "1px solid #7250C8",
                                width: "70px",
                                height: "70px",
                              }}
                            >
                              <img
                                src={url}
                                alt={name}
                                className="chat-attachment-image rounded"
                                style={{
                                  height: "68px",
                                  width: "68px",
                                }}
                                onClick={() => handleImageClick(url)}
                              />
                            </div>
                          );
                        }
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        flexDirection: "column",
                        gap: "2px",
                        paddingTop: "2px",
                      }}
                    >
                      {attachmentFile(attachments[messageId] || []).map(
                        (attachment, index) => {
                          const url = _.get(attachment, "url")
                            ? getImageUrl(_.get(attachment, "url", ""))
                            : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                          const name = _.get(attachment, "name", "");
                          const type = _.get(attachment, "type", "");
                          const iconType = fileTypeIcon(name, type);

                          return (
                            <div
                              key={index}
                              className="chat-mess-body rounded-4 p-2 px-3 border-pri"
                              style={{
                                minWidth: "150px",
                              }}
                            >
                              <div className="chat-mess-text d-flex gap-2 align-items-center">
                                {iconType === "pdf" && (
                                  <img
                                    src="/img/chat/icon/pdf.svg"
                                    alt="pdf"
                                    width={18}
                                  />
                                )}
                                {iconType === "word" && (
                                  <img
                                    src="/img/chat/icon/word.svg"
                                    alt="word"
                                    width={18}
                                  />
                                )}
                                {iconType === "excel" && (
                                  <img
                                    src="/img/chat/icon/excel.svg"
                                    alt="excel"
                                    width={18}
                                  />
                                )}
                                {iconType === "default" && (
                                  <svg
                                    className="icon"
                                    width="15"
                                    height="18"
                                    viewBox="0 0 15 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                                      fill="#211F26"
                                    />
                                  </svg>
                                )}
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={url}
                                  style={{
                                    maxWidth: "160px",
                                    direction: "rtl",
                                    textAlign: "left",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    color: "black",
                                  }}
                                  className="ellipsis-start"
                                >
                                  <strong>{name}</strong>
                                </a>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                </div>
                <div className="small mt-1 d-flex gap-1 align-items-center justify-content-end">
                  <span className="color-pri">
                    {isWidget ? t("agent.chat.you") : requester?.name || ""}
                  </span>
                  {isShowTime && (
                    <span className="color-gray fs-4 lh-1 pb-1"> • </span>
                  )}
                  {isShowTime && (
                    <span className="time color-gray">
                      {getFormattedTime(addTime)}
                    </span>
                  )}
                  {isLastMessage && <img src="/img/chat/icon/c3.svg" alt="" />}
                </div>
              </div>
            </div>
          )}
          {isWidgetStaff && (
            <div>
              <div
                className="chat-mess-box"
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="chat-mess d-flex align-items-center gap-2">
                  <div
                    className={`${getMessageBodyClass()} rounded-3`}
                    style={{
                      background: "none",
                    }}
                  >
                    {replyMessages[replyMessageId] && (
                      <div
                        className="chat-mess-reply bg-gray-light border-2 color-dark p-2"
                        onClick={() => setReplyMessageId(replyMessageId)}
                        style={{
                          borderTopLeftRadius: 8,
                          borderTopRightRadius: 8,
                        }}
                      >
                        <div className="border-start bg-gray border-2 ps-2">
                          <div>
                            {_.get(replyMessages[replyMessageId], "name", "")}
                          </div>
                          <div className="one-line small color-gray">
                            {_.get(
                              replyMessages[replyMessageId],
                              "content",
                              ""
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              paddingTop: "2px",
                              gap: "2px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "2px",
                              }}
                            >
                              {attachmentImage(
                                attachments[replyMessageId] || []
                              ).map((attachment, index) => {
                                const url = _.get(attachment, "url")
                                  ? getImageUrl(_.get(attachment, "url", ""))
                                  : _.get(
                                      attachment,
                                      "previewUrl",
                                      EMPTY_IMAGE
                                    );
                                const name = _.get(attachment, "name", "");

                                return (
                                  <div
                                    key={index}
                                    className="img rounded-2"
                                    style={{
                                      border: "1px solid #BAC6D8",
                                      backgroundColor: "white",
                                      width: "70px",
                                      height: "70px",
                                    }}
                                  >
                                    <img
                                      src={url}
                                      alt={name}
                                      className="chat-attachment-image rounded"
                                      style={{
                                        height: "68px",
                                        width: "68px",
                                      }}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "2px",
                              }}
                            >
                              {attachmentFile(
                                attachments[replyMessageId] || []
                              ).map((attachment, index) => {
                                const url = _.get(attachment, "url")
                                  ? getImageUrl(_.get(attachment, "url", ""))
                                  : _.get(
                                      attachment,
                                      "previewUrl",
                                      EMPTY_IMAGE
                                    );
                                const name = _.get(attachment, "name", "");
                                const type = _.get(attachment, "type", "");
                                const iconType = fileTypeIcon(name, type);

                                return (
                                  <div
                                    key={index}
                                    className="chat-mess-body rounded-4 p-2 px-3"
                                    style={{
                                      minWidth: "150px",
                                      border: "1px solid #BAC6D8",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <div className="chat-mess-text d-flex gap-2 align-items-center">
                                      {iconType === "pdf" && (
                                        <img
                                          src="/img/chat/icon/pdf.svg"
                                          alt="pdf"
                                          width={18}
                                        />
                                      )}
                                      {iconType === "word" && (
                                        <img
                                          src="/img/chat/icon/word.svg"
                                          alt="word"
                                          width={18}
                                        />
                                      )}
                                      {iconType === "excel" && (
                                        <img
                                          src="/img/chat/icon/excel.svg"
                                          alt="excel"
                                          width={18}
                                        />
                                      )}
                                      {iconType === "default" && (
                                        <svg
                                          className="icon"
                                          width="15"
                                          height="18"
                                          viewBox="0 0 15 18"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                                            fill="#211F26"
                                          />
                                        </svg>
                                      )}
                                      <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={url}
                                        style={{
                                          maxWidth: "160px",
                                          direction: "rtl",
                                          textAlign: "left",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          color: "black",
                                        }}
                                        className="ellipsis-start"
                                      >
                                        <strong>{name}</strong>
                                      </a>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {content && (
                      <div
                        className="chat-mess-text border bg-white p-2 px-3"
                        style={{
                          whiteSpace: "pre-wrap",
                          with: "100%",
                          borderBottomLeftRadius: 8,
                          borderBottomRightRadius: 8,
                          ...(replyMessages[replyMessageId]
                            ? {}
                            : {
                                borderTopLeftRadius: 8,
                                borderTopRightRadius: 8,
                              }),
                        }}
                      >
                        <Linkify options={optionContentWidget}>
                          {content}
                        </Linkify>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "2px",
                        paddingTop: "2px",
                      }}
                    >
                      {attachmentImage(attachments[messageId] || []).map(
                        (attachment, index) => {
                          const url = _.get(attachment, "url")
                            ? getImageUrl(_.get(attachment, "url", ""))
                            : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                          const name = _.get(attachment, "name", "");

                          return (
                            <div
                              key={index}
                              className="img rounded-2"
                              style={{
                                border: "1px solid #BAC6D8",
                                backgroundColor: "white",
                                width: "70px",
                                height: "70px",
                              }}
                            >
                              <img
                                src={url}
                                alt={name}
                                className="chat-attachment-image rounded"
                                style={{
                                  height: "68px",
                                  width: "68px",
                                }}
                                onClick={() => handleImageClick(url)}
                              />
                            </div>
                          );
                        }
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                        paddingTop: "2px",
                      }}
                    >
                      {attachmentFile(attachments[messageId] || []).map(
                        (attachment, index) => {
                          const url = _.get(attachment, "url")
                            ? getImageUrl(_.get(attachment, "url", ""))
                            : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                          const name = _.get(attachment, "name", "");
                          const type = _.get(attachment, "type", "");
                          const iconType = fileTypeIcon(name, type);

                          return (
                            <div
                              key={index}
                              className="chat-mess-body rounded-4 p-2 px-3"
                              style={{
                                minWidth: "150px",
                                border: "1px solid #BAC6D8",
                                backgroundColor: "white",
                              }}
                            >
                              <div className="chat-mess-text d-flex gap-2 align-items-center">
                                {iconType === "pdf" && (
                                  <img
                                    src="/img/chat/icon/pdf.svg"
                                    alt="pdf"
                                    width={18}
                                  />
                                )}
                                {iconType === "word" && (
                                  <img
                                    src="/img/chat/icon/word.svg"
                                    alt="word"
                                    width={18}
                                  />
                                )}
                                {iconType === "excel" && (
                                  <img
                                    src="/img/chat/icon/excel.svg"
                                    alt="excel"
                                    width={18}
                                  />
                                )}
                                {iconType === "default" && (
                                  <svg
                                    className="icon"
                                    width="15"
                                    height="18"
                                    viewBox="0 0 15 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                                      fill="#211F26"
                                    />
                                  </svg>
                                )}
                                <a
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={url}
                                  style={{
                                    maxWidth: "160px",
                                    direction: "rtl",
                                    textAlign: "left",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    color: "black",
                                  }}
                                  className="ellipsis-start"
                                >
                                  <strong>{name}</strong>
                                </a>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                  {showButton && sessionId === messageSessionId && (
                    <button
                      className="btn btn-gray-light chat-btn-reply"
                      onClick={() => onReplyMessage(message)}
                    >
                      <img src="/img/chat/icon/reply.svg" alt="" />
                    </button>
                  )}
                </div>
                <div className="small mt-1 d-flex gap-1 align-items-center">
                  <span className="color-pri">
                    {staffNameDefault || _.get(message, "name")}
                  </span>
                  {isShowTime && (
                    <span className="color-gray fs-4 lh-1 pb-1"> • </span>
                  )}
                  {isShowTime && (
                    <span className="time color-gray">
                      {getFormattedTime(addTime)}
                    </span>
                  )}
                  {isLastMessage && <img src="/img/chat/icon/c3.svg" alt="" />}
                </div>
              </div>
            </div>
          )}
          {isMeNotWidget && (
            <div className="chat-mess-box chat-mess-right">
              <div className="chat-mess d-flex align-items-center gap-2 justify-content-end">
                {showButton && sessionId === messageSessionId && (
                  <button
                    className="btn btn-gray-light chat-btn-reply"
                    onClick={() => onReplyMessage(message)}
                  >
                    <img src="/img/chat/icon/reply.svg" alt="" />
                  </button>
                )}
                <div
                  className={`${getMessageBodyClass()} rounded-3`}
                  style={{
                    background: "none",
                  }}
                >
                  {replyMessages[replyMessageId] && (
                    <div
                      style={{
                        backgroundColor: "#EDD6F9",
                        color: "black",
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                      }}
                      className="chat-mess-reply bg-gray-light p-2"
                      onClick={() => setReplyMessageId(replyMessageId)}
                    >
                      <div className="border-start bg-gray border-2 ps-2">
                        <div>
                          {_.get(replyMessages[replyMessageId], "name", "")}
                        </div>
                        <div className="one-line small color-gray">
                          {_.get(replyMessages[replyMessageId], "content", "")}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            paddingTop: "2px",
                            gap: "2px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              justifyContent: "flex-end",
                              gap: "2px",
                            }}
                          >
                            {attachmentImage(
                              attachments[replyMessageId] || []
                            ).map((attachment, index) => {
                              const url = _.get(attachment, "url")
                                ? getImageUrl(_.get(attachment, "url", ""))
                                : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                              const name = _.get(attachment, "name", "");

                              return (
                                <div
                                  key={index}
                                  className="img rounded-2"
                                  style={{
                                    backgroundColor: "#EBE5F6",
                                    border: "1px solid #7250C8",
                                    width: "70px",
                                    height: "70px",
                                  }}
                                >
                                  <img
                                    src={url}
                                    alt={name}
                                    className="chat-attachment-image rounded"
                                    style={{
                                      height: "68px",
                                      width: "68px",
                                    }}
                                  />
                                </div>
                              );
                            })}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-end",
                              flexDirection: "column",
                              gap: "2px",
                            }}
                          >
                            {attachmentFile(
                              attachments[replyMessageId] || []
                            ).map((attachment, index) => {
                              const url = _.get(attachment, "url")
                                ? getImageUrl(_.get(attachment, "url", ""))
                                : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                              const name = _.get(attachment, "name", "");
                              const type = _.get(attachment, "type", "");
                              const iconType = fileTypeIcon(name, type);

                              return (
                                <div
                                  key={index}
                                  className="chat-mess-body rounded-4 p-2 px-3 border-pri"
                                  style={{
                                    minWidth: "150px",
                                    border: "1px solid #7250C8",
                                  }}
                                >
                                  <div className="chat-mess-text d-flex gap-2 align-items-center">
                                    {iconType === "pdf" && (
                                      <img
                                        src="/img/chat/icon/pdf.svg"
                                        alt="pdf"
                                        width={18}
                                      />
                                    )}
                                    {iconType === "word" && (
                                      <img
                                        src="/img/chat/icon/word.svg"
                                        alt="word"
                                        width={18}
                                      />
                                    )}
                                    {iconType === "excel" && (
                                      <img
                                        src="/img/chat/icon/excel.svg"
                                        alt="excel"
                                        width={18}
                                      />
                                    )}
                                    {iconType === "default" && (
                                      <svg
                                        className="icon"
                                        width="15"
                                        height="18"
                                        viewBox="0 0 15 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                                          fill="#211F26"
                                        />
                                      </svg>
                                    )}
                                    <a
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={url}
                                      style={{
                                        maxWidth: "160px",
                                        direction: "rtl",
                                        textAlign: "left",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        color: "black",
                                      }}
                                      className="ellipsis-start"
                                    >
                                      <strong>{name}</strong>
                                    </a>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {content && (
                    <div
                      className="chat-mess-text content-me-widget p-2 px-3"
                      style={{
                        whiteSpace: "pre-wrap",
                        with: "100%",
                        borderBottomLeftRadius: 8,
                        borderBottomRightRadius: 8,
                        ...(replyMessages[replyMessageId]
                          ? {}
                          : {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                            }),
                      }}
                    >
                      <Linkify options={optionContentWidget}>{content}</Linkify>
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "flex-end",
                      gap: "2px",
                      paddingTop: "2px",
                    }}
                  >
                    {attachmentImage(attachments[messageId] || []).map(
                      (attachment, index) => {
                        const url = _.get(attachment, "url")
                          ? getImageUrl(_.get(attachment, "url", ""))
                          : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                        const name = _.get(attachment, "name", "");

                        return (
                          <div
                            key={index}
                            className="img rounded-2"
                            style={{
                              backgroundColor: "#EBE5F6",
                              border: "1px solid #7250C8",
                              width: "70px",
                              height: "70px",
                            }}
                          >
                            <img
                              src={url}
                              alt={name}
                              className="chat-attachment-image rounded"
                              style={{
                                height: "68px",
                                width: "68px",
                              }}
                              onClick={() => handleImageClick(url)}
                            />
                          </div>
                        );
                      }
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      flexDirection: "column",
                      gap: "2px",
                      paddingTop: "2px",
                    }}
                  >
                    {attachmentFile(attachments[messageId] || []).map(
                      (attachment, index) => {
                        const url = _.get(attachment, "url")
                          ? getImageUrl(_.get(attachment, "url", ""))
                          : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                        const name = _.get(attachment, "name", "");
                        const type = _.get(attachment, "type", "");
                        const iconType = fileTypeIcon(name, type);

                        return (
                          <div
                            key={index}
                            className="chat-mess-body rounded-4 p-2 px-3 border-pri"
                            style={{
                              minWidth: "150px",
                              border: "1px solid #7250C8",
                            }}
                          >
                            <div className="chat-mess-text d-flex gap-2 align-items-center">
                              {iconType === "pdf" && (
                                <img
                                  src="/img/chat/icon/pdf.svg"
                                  alt="pdf"
                                  width={18}
                                />
                              )}
                              {iconType === "word" && (
                                <img
                                  src="/img/chat/icon/word.svg"
                                  alt="word"
                                  width={18}
                                />
                              )}
                              {iconType === "excel" && (
                                <img
                                  src="/img/chat/icon/excel.svg"
                                  alt="excel"
                                  width={18}
                                />
                              )}
                              {iconType === "default" && (
                                <svg
                                  className="icon"
                                  width="15"
                                  height="18"
                                  viewBox="0 0 15 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                                    fill="#211F26"
                                  />
                                </svg>
                              )}
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={url}
                                style={{
                                  maxWidth: "160px",
                                  direction: "rtl",
                                  textAlign: "left",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  color: "black",
                                }}
                                className="ellipsis-start"
                              >
                                <strong>{name}</strong>
                              </a>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
              <div className="small mt-1 d-flex gap-1 align-items-center justify-content-end">
                <span className="color-pri">{t("agent.chat.you")}</span>
                {isShowTime && (
                  <span className="color-gray fs-4 lh-1 pb-1"> • </span>
                )}
                {isShowTime && (
                  <span className="time color-gray">
                    {getFormattedTime(addTime)}
                  </span>
                )}
                {isLastMessage && !isSeen && (
                  <img src="/img/chat/icon/c3.svg" alt="" />
                )}
                {isSeen && (
                  <img
                    style={{ width: "17px", height: "17px" }}
                    src="/img/chat/icon/seen.svg"
                    alt=""
                  />
                )}
              </div>
            </div>
          )}
          {isOtherNotWidget && (
            <div className="chat-mess-box">
              <div className="chat-mess d-flex align-items-center gap-2">
                <div
                  className={`${getMessageBodyClass()} rounded-3`}
                  style={{
                    background: "none",
                  }}
                >
                  {replyMessages[replyMessageId] && (
                    <div
                      className="chat-mess-reply bg-gray-light border-2 color-dark p-2"
                      onClick={() => setReplyMessageId(replyMessageId)}
                      style={{
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                      }}
                    >
                      <div className="border-start bg-gray border-2 ps-2">
                        <div>
                          {_.get(replyMessages[replyMessageId], "name", "")}
                        </div>
                        <div className="one-line small color-gray">
                          {_.get(replyMessages[replyMessageId], "content", "")}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            paddingTop: "2px",
                            gap: "2px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "2px",
                            }}
                          >
                            {attachmentImage(
                              attachments[replyMessageId] || []
                            ).map((attachment, index) => {
                              const url = _.get(attachment, "url")
                                ? getImageUrl(_.get(attachment, "url", ""))
                                : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                              const name = _.get(attachment, "name", "");

                              return (
                                <div
                                  key={index}
                                  className="img rounded-2"
                                  style={{
                                    border: "1px solid #BAC6D8",
                                    backgroundColor: "white",
                                    width: "70px",
                                    height: "70px",
                                  }}
                                >
                                  <img
                                    src={url}
                                    alt={name}
                                    className="chat-attachment-image rounded"
                                    style={{
                                      height: "68px",
                                      width: "68px",
                                    }}
                                  />
                                </div>
                              );
                            })}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "2px",
                            }}
                          >
                            {attachmentFile(
                              attachments[replyMessageId] || []
                            ).map((attachment, index) => {
                              const url = _.get(attachment, "url")
                                ? getImageUrl(_.get(attachment, "url", ""))
                                : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                              const name = _.get(attachment, "name", "");
                              const type = _.get(attachment, "type", "");
                              const iconType = fileTypeIcon(name, type);

                              return (
                                <div
                                  key={index}
                                  className="chat-mess-body rounded-4 p-2 px-3 border-pri"
                                  style={{
                                    minWidth: "150px",
                                    border: "1px solid #BAC6D8",
                                    backgroundColor: "white",
                                  }}
                                >
                                  <div className="chat-mess-text d-flex gap-2 align-items-center">
                                    {iconType === "pdf" && (
                                      <img
                                        src="/img/chat/icon/pdf.svg"
                                        alt="pdf"
                                        width={18}
                                      />
                                    )}
                                    {iconType === "word" && (
                                      <img
                                        src="/img/chat/icon/word.svg"
                                        alt="word"
                                        width={18}
                                      />
                                    )}
                                    {iconType === "excel" && (
                                      <img
                                        src="/img/chat/icon/excel.svg"
                                        alt="excel"
                                        width={18}
                                      />
                                    )}
                                    {iconType === "default" && (
                                      <svg
                                        className="icon"
                                        width="15"
                                        height="18"
                                        viewBox="0 0 15 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                                          fill="#211F26"
                                        />
                                      </svg>
                                    )}
                                    <a
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={url}
                                      style={{
                                        maxWidth: "160px",
                                        direction: "rtl",
                                        textAlign: "left",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        color: "black",
                                      }}
                                      className="ellipsis-start"
                                    >
                                      <strong>{name}</strong>
                                    </a>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {content && (
                    <div
                      className="chat-mess-text border bg-white p-2 px-3"
                      style={{
                        whiteSpace: "pre-wrap",
                        with: "100%",
                        borderBottomLeftRadius: 8,
                        borderBottomRightRadius: 8,
                        ...(replyMessages[replyMessageId]
                          ? {}
                          : {
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                            }),
                      }}
                    >
                      <Linkify options={optionContentWidget}>{content}</Linkify>
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "2px",
                      paddingTop: "2px",
                    }}
                  >
                    {attachmentImage(attachments[messageId] || []).map(
                      (attachment, index) => {
                        const url = _.get(attachment, "url")
                          ? getImageUrl(_.get(attachment, "url", ""))
                          : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                        const name = _.get(attachment, "name", "");

                        return (
                          <div
                            key={index}
                            className="img rounded-2"
                            style={{
                              border: "1px solid #BAC6D8",
                              backgroundColor: "white",
                              width: "70px",
                              height: "70px",
                            }}
                          >
                            <img
                              src={url}
                              alt={name}
                              className="chat-attachment-image rounded"
                              style={{
                                height: "68px",
                                width: "68px",
                              }}
                              onClick={() => handleImageClick(url)}
                            />
                          </div>
                        );
                      }
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                      paddingTop: "2px",
                    }}
                  >
                    {attachmentFile(attachments[messageId] || []).map(
                      (attachment, index) => {
                        const url = _.get(attachment, "url")
                          ? getImageUrl(_.get(attachment, "url", ""))
                          : _.get(attachment, "previewUrl", EMPTY_IMAGE);
                        const name = _.get(attachment, "name", "");
                        const type = _.get(attachment, "type", "");
                        const iconType = fileTypeIcon(name, type);

                        return (
                          <div
                            key={index}
                            className="chat-mess-body rounded-4 p-2 px-3 border-pri"
                            style={{
                              minWidth: "150px",
                              border: "1px solid #BAC6D8",
                              backgroundColor: "white",
                            }}
                          >
                            <div className="chat-mess-text d-flex gap-2 align-items-center">
                              {iconType === "pdf" && (
                                <img
                                  src="/img/chat/icon/pdf.svg"
                                  alt="pdf"
                                  width={18}
                                />
                              )}
                              {iconType === "word" && (
                                <img
                                  src="/img/chat/icon/word.svg"
                                  alt="word"
                                  width={18}
                                />
                              )}
                              {iconType === "excel" && (
                                <img
                                  src="/img/chat/icon/excel.svg"
                                  alt="excel"
                                  width={18}
                                />
                              )}
                              {iconType === "default" && (
                                <svg
                                  className="icon"
                                  width="15"
                                  height="18"
                                  viewBox="0 0 15 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                                    fill="#211F26"
                                  />
                                </svg>
                              )}
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={url}
                                style={{
                                  maxWidth: "160px",
                                  direction: "rtl",
                                  textAlign: "left",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  color: "black",
                                }}
                                className="ellipsis-start"
                              >
                                <strong>{name}</strong>
                              </a>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
                {showButton && sessionId === messageSessionId && (
                  <button
                    className="btn btn-gray-light chat-btn-reply"
                    onClick={() => onReplyMessage(message)}
                  >
                    <img src="/img/chat/icon/reply.svg" alt="" />
                  </button>
                )}
              </div>
              <div className="small mt-1 gap-1 d-flex align-items-center">
                <span className="color-pri">
                  {isRequester
                    ? requester?.name
                    : staffs[messageStaffId]?.name || ""}
                </span>
                {isShowTime && (
                  <span className="color-gray fs-4 lh-1 pb-1"> • </span>
                )}
                {isShowTime && (
                  <span className="time color-gray">
                    {getFormattedTime(addTime)}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <Popup
        config={{
          isOpen: isImageOpen,
          onClose: handleCloseImage,
          style: { maxWidth: "90%", maxHeight: "90%", overflow: "auto" },
          className: "popup-image-preview",
          isBackground: true,
        }}
      >
        {imageSrc && (
          <img
            src={imageSrc}
            alt="Preview"
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              display: "block",
              margin: "0 auto",
              objectFit: "contain",
            }}
          />
        )}
      </Popup>
    </div>
  );
};

export default ChatContent;
